import { useState, useEffect, useContext } from 'react';
import {Image} from "semantic-ui-react";
import { Link, useParams, useSearchParams } from 'react-router-dom';

import SearchBox from 'src/components/SearchBox';
import SearchContext from 'src/context/SearchContext';
import Logo from 'src/components/Logo';
import logoVet from '/img/imago_veterinaria.svg'

// const showBar = true;

const Header = ({showBar}) => {
    const [searchParams] = useSearchParams();
    const {id} = useParams();

    const [tema, setTema] = useState(searchParams.get('tema')?.trim());
    const [query, setQuery] = useState(searchParams.get('query')?.trim());
    useEffect(() => {
        // console.log('searchParams', searchParams.get('query'), searchParams.get('tema'));
        setTema(searchParams.get('tema')?.trim());
        setQuery(searchParams.get('query')?.trim());
    }, [searchParams]);

    return (
        <div id="header" className={` ${showBar ? 'head-search' : ''}`}>
            <Logo />

            {showBar ? <SearchBox /> : <div></div>}

            <div className="logo _r">
                <Link to="/" className="no-txt"> <span>Ir a Home</span> <Image src={logoVet} alt="Logo Veterinaria"/> </Link>
            </div>
        </div>
    );
};

export default Header;
